import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { useSubscriptionStore } from '@/stores';

import { getIsPhysicalBatteryEnabled } from '@/utils/env.util';

function useEncoreDiscount() {
  const { getBudgetBreakdown } = storeToRefs(useSubscriptionStore());

  const encoreDiscount = computed(() => {
    const physicalBatteryOption = getBudgetBreakdown.value?.options.physicalBatteryOption;
    if (!getIsPhysicalBatteryEnabled() || !physicalBatteryOption) {
      return null;
    }

    return {
      monthly: Math.abs(physicalBatteryOption.totalMonthlyPrice),
      annual: Math.abs(physicalBatteryOption.totalAnnualPrice),
    };
  });

  return { encoreDiscount };
}

export default useEncoreDiscount;
